import { Marker, GoogleMap, LoadScript } from '@react-google-maps/api';
import axios from 'axios';
import { useKeysStore } from '../../../../store/useKeysStore';
import { useCallback } from 'react';

function CustomMap(props) {
    const { keys } = useKeysStore();
    const containerStyle = {
        width: '100%',
        height: '400px'
    };

    const handleMarkerDragEnd = useCallback(async (event) => {
        const { latLng } = event;
        const lat = latLng.lat();
        const lng = latLng.lng();

        const addressInfo = await axios
            .get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${keys?.gmaps_key}`
            )
            .then((resp) => {
                const data = resp.data.results;

                return {
                    address_number: data[0].address_components[0]?.long_name,
                    street_name: data[0].address_components[1]?.long_name,
                    district: data[0].address_components[2]?.long_name,
                    city: data[0].address_components[3]?.long_name,
                    state: data[0].address_components[4]?.long_name,
                    zipcode: data[0].address_components[6]?.long_name
                };
            });

        props.setMarkerPosition({ lat, lng, addressInfo });
    }, [props, keys?.gmaps_key]);

    return (
        <LoadScript googleMapsApiKey={keys?.gmaps_key}>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={props.markerPosition}
                zoom={17}
            >
                <Marker
                    position={props.markerPosition}
                    draggable={true}
                    onDragEnd={handleMarkerDragEnd}
                />
            </GoogleMap>
        </LoadScript>
    );
}

export default CustomMap;
